/**
 * OJB brand tokens — single source of truth for all app surfaces.
 * Path A font strategy: Inter on web + PDF, Aeonik named in .docx only
 * (OJB-licensed Desktop EULA does not permit @font-face or server install).
 *
 * Deprecated brand patterns (do NOT reintroduce):
 *   - Tri-color band (pine + sage + terra-cotta as a 3-segment bar) —
 *     removed from page styling per pilot direction. terraCotta + sage
 *     stay in the palette here for legacy theme variants and the docx
 *     brand file, but the BAR PATTERN itself is no longer part of
 *     OJB's brand standards for this app.
 */
export const COLORS = {
    // Primary
    charcoal: '#2B2A2F', // logo, primary text
    cloud: '#EAE9E5', // label cells, footer bar shading
    terraCotta: '#B16C4C', // legacy doc template accent (NOT used — Pine replaces)
    jade: '#769D91', // brand palette, not used in this tool
    // Secondary / accents
    pine: '#375542', // THE accent for this tool (UI + document output)
    sage: '#C3C6A7',
    smoke: '#9EA1A2', // 0.5pt divider rules
    // Utility
    white: '#FFFFFF',
    black: '#000000',
};
export const FONT_STACK = {
    // Web UI + PDF: Inter (free, metrically similar to Aeonik)
    ui: [
        'Inter',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Arial',
        'sans-serif',
    ].join(', '),
    // .docx output: name Aeonik explicitly; Word substitutes on end-user machines
    docx: 'Aeonik',
    // Arial fallback for .docx if recipient lacks Aeonik (per OJB Style Guide)
    docxFallback: 'Arial',
};
/**
 * OJB offices for the left-margin ribbon in the document template.
 */
export const OJB_OFFICES = [
    { city: 'Boston', state: 'MASSACHUSETTS' },
    { city: 'Dallas', state: 'TEXAS' },
    { city: 'Denver', state: 'COLORADO' },
    { city: 'Houston', state: 'TEXAS' },
    { city: 'Philadelphia', state: 'PENNSYLVANIA' },
    { city: 'San Diego', state: 'CALIFORNIA' },
];
export const OJB_DOMAIN = 'ojb.com';
export const OJB_URL_LABEL = 'OJB.COM';
//# sourceMappingURL=brand.js.map